import { Heading, Paragraph } from '@zillow/constellation';
import React from 'react';

interface Props {
  isComplete: boolean;
}

export function ReviewStatusText({ isComplete }: Props) {
  return (
    <>
      <Heading level={5} as="h2">
        {isComplete ? `Your application is almost done!` : `Review your application`}
      </Heading>
      <Paragraph fontType="bodySmall">
        {isComplete
          ? `All that’s left to do is give permission to view your application and submit.`
          : `There are some sections you need to finish. Once your application is complete, you’ll be able to submit.`}
      </Paragraph>
    </>
  );
}
